import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';
import { useTranslation } from '../lib/i18n';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center">
      <div className="text-center space-y-6 p-8">
        <div className="flex justify-center">
          <FileQuestion className="h-24 w-24 text-blue-500 dark:text-blue-400" />
        </div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100">
          {t('notFound.title')}
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-md mx-auto">
          {t('notFound.description')}
        </p>
        <div className="flex justify-center gap-4">
          <Button onClick={() => window.history.back()} variant="outline">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('notFound.goBack')}
          </Button>
          <Link to="/">
            <Button>
              <Home className="w-4 h-4 mr-2" />
              {t('notFound.returnHome')}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
